import React from 'react';
import styles from './styles.module.scss';

import { FormDayPicker } from 'components/FormComponents';

import { FormProvider, useForm } from 'react-hook-form';

import { formatDate, startOfCurrentYear } from 'helpers/AppHelpers';

import EditableContent from '../EditableContent';

export default function PickupDateCellContent({ row, onEdit, isEditable }) {
  const { pickupDate } = row;

  const methods = useForm({
    defaultValues: {
      pickupDate
    }
  });
  const { getValues, setValue } = methods;

  const setDefaultValue = () => setValue('pickupDate', pickupDate);

  const handleAcceptClick = () => {
    onEdit({ ...row, pickupDate: getValues('pickupDate') });
  };

  return (
    <EditableContent
      onAccept={handleAcceptClick}
      isEditable={isEditable}
      setDefaultValue={setDefaultValue}
      hoverPencil
      renderDisplayedComponent={() => <>{pickupDate ? formatDate(pickupDate) : '\u2000'}</>}
      renderEditor={() => (
        <FormProvider {...methods}>
          <FormDayPicker
            name="pickupDate"
            clearable
            min={startOfCurrentYear}
            className={styles.pickupDate__field}
          />
        </FormProvider>
      )}
    />
  );
}
